import { css } from '@/styled-system/css';

// Page root styles for inbox - makes Page.Root a flex container that fills viewport
export const inboxPageRootStyles = css.raw({
  height: '100dvh',
  display: 'flex',
  flexDirection: 'column',

  // Override the BodyContainer's from zrm-header-navigation AppLayoutContainer
  // This is necessary to support the inbox page's MessageList scrolling
  '& [data-testid="BodyContainer"]': {
    display: 'flex',
    flexDirection: 'column',
  },
});

// Wrapper styles for AppLayoutContainer - fills remaining space after any banners
export const inboxAppLayoutContainerStyles = css.raw({
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

// Main content styles for inbox
export const inboxMainContentStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
});

export const pageContentStyles = css.raw({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  paddingInline: { base: '0', xl: 'loose' },
});

export const rentalJourneyFiltersRowStyles = css.raw({
  display: 'flex',
  overflowX: 'auto',
  flexShrink: 0,
  paddingLeft: { base: 'default', xxl: '0' },
  paddingTop: { base: 'tight', xxl: '0' },
  paddingBottom: 'tight',
  marginTop: { base: 'tight', xxl: '0' },
});

export const columnWrapperStyles = css.raw({
  height: '100%',
  display: 'flex',
  overflowY: 'auto',
  xxl: {
    width: '100%',
    border: '1px solid',
    borderColor: 'border.muted',
    borderRadius: '300',
    marginBottom: 'loose',
  },
});

export const primaryColumnStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  width: '100%',
  minHeight: 0, // Allows flex children to shrink
  xxl: {
    maxWidth: '25%',
    borderRight: '1px solid',
    borderRightColor: 'border.muted',
  },

  // Used for the swipeable mweb Conversation list
  '& .swipeable-list': {
    flex: 1,
    width: '100%',
    minHeight: 0,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  '& .swipeable-list-item': {
    position: 'relative',
    transition: 'max-height 0.5s ease',
    maxHeight: '1000px',
    transformOrigin: 'top',
    overflow: 'hidden',
    width: '100%',
    zIndex: 0,
  },
  '& .swipeable-list-item__content': {
    width: '100%',
    alignItems: 'center',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    height: '100%',
    display: 'flex',
  },
  '& .swipeable-list-item__content--return': {
    transition: 'transform 0.5s ease-out',
  },
  '& .swipeable-list-item__content--remove': {
    transition: 'transform 0.35s ease-in',
  },
  '& .swipeable-list-item__content-right': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    boxSizing: 'border-box',
    opacity: 0,
  },
  '& .swipeable-list-item__content-right--return': {
    transition: 'opacity 0.5s ease-out',
  },
  '& .swipeable-list-item__content-left': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    boxSizing: 'border-box',
    opacity: 0,
    justifyContent: 'flex-end',
  },
  '& .swipeable-list-item__content-left--return': {
    transition: 'opacity 0.5s ease-out',
  },
});

export const tertiaryColumnStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  width: '100%',
  minHeight: 0, // Allows flex children to shrink
  xxl: {
    maxWidth: '25%',
    minWidth: '285px',
  },
});
